module.exports = __webpack_public_path__ + "img/top-img01.dc354571.png";